import type { UpdateSettingsDto } from 'api';

export function useSettings() {
  return {
    settings: undefined,
    isLoading: false,
    updateSettings: (_dto: UpdateSettingsDto) => {},
  };
}
